import Tracing from "../../tracing/Tracing";

class Customer {
    constructor(data) {
        this.changed = false;
        this.update(data);
    }

    update(data) {
        Tracing.setUser({
            id: data.id,
            email: data.email,
            username: `${data.vorname} ${data.nachname}`,
            geo: {
                city: data.ort,
            },
        });

        for (let i in data) {
            if (data.hasOwnProperty(i)) {
                this[i] = data[i];
            }
        }
    }
}

export default Customer;
